// @flow

export const FEATURES = {
    WEB_ADMIN_LOGIN_AS: 'web_admin_login_as',
    WEB_ADMIN: 'web_admin',
    WEB_NOTIFICATIONS: 'web_notifications',
    WEB_NOTIFICATION_CENTER_V1: 'web_notification_center_v1',
    WEB_MESSAGING_V1: 'web_messaging_v1',
    COACH_PRICING: 'coach_pricing',
    WEB_COACH_HOME: 'web_coach_home',
    MOBILE_LOW_PROGRAMMING: 'mobile_low_programming',
    MARKETPLACE_SHOP_SETTINGS: 'marketplace_shop_settings',
    PARENTAL_CONSENT_V2: 'parental_consent_v2',
    WEB_COACH_SHOW_NUTRITION_ON_CALENDAR_V1:
        'web_coach_show_nutrition_on_calendar_v1',
    WEB_COACH_SUGGESTED_SWAPS_V1: 'web_coach_suggested_swaps_v1',
    WEB_COACH_FULLSCREEN_WORKOUT_PREVIEW_V1:
        'web_coach_fullscreen_workout_preview_v1'
};



// WEBPACK FOOTER //
// ./src/v5/features/components/constants.js